(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.AlvauraOfferQuote = factory();
}(typeof globalThis === 'object' ? globalThis : this, function () {
  'use strict';

  var currencies = 'AED AUD CAD CHF CNY DKK EUR GBP HKD IDR ILS INR MXN MYR NOK NZD PHP PLN RON SAR SEK SGD THB TRY TWD USD ZAR'.split(' ');
  var ineligibleCodeWarnings = 'DISCOUNT_CODE_NOT_HONOURED DISCOUNT_CURRENTLY_INACTIVE DISCOUNT_CUSTOMER_NOT_ELIGIBLE DISCOUNT_CUSTOMER_USAGE_LIMIT_REACHED DISCOUNT_ELIGIBLE_CUSTOMER_MISSING DISCOUNT_INCOMPATIBLE_PURCHASE_TYPE DISCOUNT_NO_ENTITLED_LINE_ITEMS DISCOUNT_NOT_FOUND DISCOUNT_PURCHASE_NOT_IN_RANGE DISCOUNT_QUANTITY_NOT_IN_RANGE DISCOUNT_USAGE_LIMIT_REACHED'.split(' ');
  var cartFields = 'fragment OfferCart on Cart { id totalQuantity buyerIdentity { countryCode } cost { subtotalAmount { amount currencyCode } totalAmount { amount currencyCode } } discountCodes { code applicable } lines(first: 2) { nodes { id quantity merchandise { ... on ProductVariant { id } } ... on CartLine { sellingPlanAllocation { sellingPlan { id name } priceAdjustments { price { amount currencyCode } compareAtPrice { amount currencyCode } } } } cost { amountPerQuantity { amount currencyCode } subtotalAmount { amount currencyCode } totalAmount { amount currencyCode } } discountAllocations(lineLevelOnly: false) { __typename discountedAmount { amount currencyCode } ... on CartAutomaticDiscountAllocation { title } ... on CartCodeDiscountAllocation { code } } } pageInfo { hasNextPage } } }';
  var operations = {
    create: 'mutation OfferCreate($input: CartInput!) { result: cartCreate(input: $input) { cart { ...OfferCart } userErrors { code } warnings { code } } } ' + cartFields,
    prepare: 'mutation OfferPrepare($cartId: ID!, $country: CountryCode!, $lines: [CartLineUpdateInput!]!) { reset: cartDiscountCodesUpdate(cartId: $cartId, discountCodes: []) { userErrors { code } warnings { code } } identity: cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: {countryCode: $country}) { userErrors { code } warnings { code } } result: cartLinesUpdate(cartId: $cartId, lines: $lines) { cart { ...OfferCart } userErrors { code } warnings { code } } } ' + cartFields,
    codes: 'mutation OfferCodes($cartId: ID!, $codes: [String!]!) { result: cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $codes) { cart { ...OfferCart } userErrors { code } warnings { code } } } ' + cartFields,
    country: 'mutation OfferCountry($cartId: ID!, $country: CountryCode!) { result: cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: {countryCode: $country}) { cart { ...OfferCart } userErrors { code } warnings { code } } } ' + cartFields,
    cleanup: 'mutation OfferCleanup($cartId: ID!, $lineIds: [ID!]!) { reset: cartDiscountCodesUpdate(cartId: $cartId, discountCodes: []) { userErrors { code } warnings { code } } result: cartLinesRemove(cartId: $cartId, lineIds: $lineIds) { cart { id lines(first: 2) { nodes { id } pageInfo { hasNextPage } } discountCodes { code applicable } } userErrors { code } warnings { code } } }'
  };

  function failure(code) {
    var error = new Error(code);
    error.code = code;
    return error;
  }

  function requireValue(condition, code) {
    if (!condition) throw failure(code);
  }

  function safeInteger(value) {
    return typeof value === 'number' && Number.isSafeInteger(value);
  }

  function moneyCents(money, currency) {
    requireValue(money && money.currencyCode === currency && typeof money.amount === 'string', 'INVALID_MONEY');
    var match = /^(0|[1-9]\d*)(?:\.(\d{1,2}))?$/.exec(money.amount);
    requireValue(match !== null, 'INVALID_MONEY');
    var major = Number(match[1]);
    var minor = match[2] ? Number((match[2] + '0').slice(0, 2)) : 0;
    var result = major * 100 + minor;
    requireValue(Number.isSafeInteger(result) && result >= 0, 'INVALID_MONEY');
    return result;
  }

  function resourceId(value, kind, nullable) {
    if (nullable && (value === '' || value === null || value === undefined)) return null;
    if (typeof value === 'number') {
      requireValue(Number.isSafeInteger(value) && value > 0, 'INVALID_CONTEXT');
      value = String(value);
    }
    requireValue(typeof value === 'string', 'INVALID_CONTEXT');
    if (/^[1-9]\d*$/.test(value)) return 'gid://shopify/' + kind + '/' + value;
    requireValue(new RegExp('^gid://shopify/' + kind + '/[1-9]\\d*$').test(value), 'INVALID_CONTEXT');
    return value;
  }

  function contextCopy(value) {
    requireValue(value && typeof value === 'object', 'INVALID_CONTEXT');
    var status = value.customerStatus === undefined ? value.status : value.customerStatus;
    requireValue(value.status === undefined || value.customerStatus === undefined || value.status === value.customerStatus, 'INVALID_CONTEXT');
    requireValue(['guest', 'new', 'returning'].indexOf(status) !== -1, 'INVALID_CONTEXT');
    requireValue(safeInteger(value.quantity) && value.quantity > 0 && value.quantity <= 1000, 'INVALID_CONTEXT');
    requireValue(safeInteger(value.unitCents) && value.unitCents > 0 && Number.isSafeInteger(value.unitCents * value.quantity), 'INVALID_CONTEXT');
    requireValue(typeof value.country === 'string' && /^[A-Z]{2}$/.test(value.country), 'INVALID_CONTEXT');
    requireValue(currencies.indexOf(value.currency) !== -1, 'UNSUPPORTED_CURRENCY');
    return {
      variantId: resourceId(value.variantId, 'ProductVariant', false),
      sellingPlanId: resourceId(value.sellingPlanId, 'SellingPlan', true),
      quantity: value.quantity,
      country: value.country,
      currency: value.currency,
      unitCents: value.unitCents,
      customerStatus: status
    };
  }

  function codeValue(value) {
    requireValue(typeof value === 'string' && /^[A-Za-z0-9][A-Za-z0-9_-]{0,63}$/.test(value), 'INVALID_CODE_CONFIGURATION');
    return value;
  }

  function createSingleSession(fetchImpl, endpoint, options) {
    requireValue(typeof fetchImpl === 'function', 'INVALID_FETCH');
    requireValue(typeof endpoint === 'string' && /^\/api\/20\d{2}-(01|04|07|10)\/graphql\.json$/.test(endpoint), 'INVALID_ENDPOINT');
    options = options || {};
    var welcomeCode = codeValue(options.welcomeCode === undefined ? 'Welcome20' : options.welcomeCode);
    var publicCodes = options.publicCodes === undefined ? [] : options.publicCodes;
    requireValue(Array.isArray(publicCodes) && publicCodes.length <= 5, 'INVALID_CODE_CONFIGURATION');
    publicCodes = publicCodes.map(codeValue);
    var seenCodes = Object.create(null);
    publicCodes.forEach(function (code) {
      var normalized = code.toUpperCase();
      requireValue(normalized !== welcomeCode.toUpperCase() && !seenCodes[normalized], 'INVALID_CODE_CONFIGURATION');
      seenCodes[normalized] = true;
    });
    var cartId = null;
    var lineId = null;
    var cleanupLineIds = [];
    var createAttempted = false;
    var failed = false;
    var disposalRequested = false;
    var disposalPromise = null;
    var queue = Promise.resolve();

    function serialize(operation) {
      var pending = queue.then(operation, operation);
      queue = pending.catch(function () {});
      return pending;
    }

    function rememberCart(cart) {
      if (!cart || typeof cart.id !== 'string' || !cart.id) return;
      if (cartId !== null && cart.id !== cartId) throw failure('CART_CONTEXT_MISMATCH');
      cartId = cart.id;
      if (cart.lines && Array.isArray(cart.lines.nodes)) cleanupLineIds = cart.lines.nodes.map(function (line) { return line.id; }).filter(function (id) { return typeof id === 'string' && id.length > 0; });
      if (cart.lines && Array.isArray(cart.lines.nodes) && cart.lines.nodes.length === 1 && typeof cart.lines.nodes[0].id === 'string') lineId = cart.lines.nodes[0].id;
    }

    async function request(operation, variables, budget, allowAfterDispose) {
      requireValue(!disposalRequested || operation === 'cleanup' || allowAfterDispose === true, 'SESSION_DISPOSED');
      budget.count += 1;
      requireValue(budget.count <= 8, 'REQUEST_BUDGET_EXCEEDED');
      var response;
      var body;
      try {
        response = await fetchImpl(endpoint, {
          method: 'POST',
          credentials: 'omit',
          cache: 'no-store',
          redirect: 'error',
          keepalive: operation === 'cleanup',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({query: operations[operation], variables: variables})
        });
        requireValue(response && response.ok === true, 'QUOTE_REQUEST_FAILED');
        body = await response.json();
      } catch (error) {
        throw failure('QUOTE_REQUEST_FAILED');
      }
      if (body && body.data && body.data.result && body.data.result.cart) rememberCart(body.data.result.cart);
      requireValue(body && (!body.errors || body.errors.length === 0) && body.data && typeof body.data === 'object', 'QUOTE_ENGINE_ERROR');
      Object.keys(body.data).forEach(function (key) {
        var payload = body.data[key];
        requireValue(payload && Array.isArray(payload.userErrors) && payload.userErrors.length === 0, 'QUOTE_ENGINE_ERROR');
        requireValue(Array.isArray(payload.warnings) && payload.warnings.every(function (warning) {
          return operation === 'codes' && key === 'result' && warning && ineligibleCodeWarnings.indexOf(warning.code) !== -1;
        }), 'QUOTE_ENGINE_WARNING');
      });
      requireValue(body.data.result && body.data.result.cart, 'QUOTE_ENGINE_ERROR');
      return body.data.result.cart;
    }

    function quoteFromCart(cart, context, allowWelcome, nativeBaseline) {
      requireValue(cart && cart.id === cartId && cart.buyerIdentity && cart.buyerIdentity.countryCode === context.country, 'CART_CONTEXT_MISMATCH');
      requireValue(cart.lines && Array.isArray(cart.lines.nodes) && cart.lines.nodes.length === 1 && cart.lines.pageInfo && cart.lines.pageInfo.hasNextPage === false, 'INVALID_QUOTE_LINES');
      var line = cart.lines.nodes[0];
      requireValue(line.id === lineId && line.quantity === context.quantity && cart.totalQuantity === context.quantity, 'CART_CONTEXT_MISMATCH');
      requireValue(line.merchandise && line.merchandise.id === context.variantId, 'CART_CONTEXT_MISMATCH');
      var plan = line.sellingPlanAllocation && line.sellingPlanAllocation.sellingPlan ? line.sellingPlanAllocation.sellingPlan.id : null;
      requireValue(plan === context.sellingPlanId, 'CART_CONTEXT_MISMATCH');
      requireValue(line.cost && cart.cost, 'INVALID_MONEY');
      var unit = moneyCents(line.cost.amountPerQuantity, context.currency);
      var subtotal = moneyCents(line.cost.subtotalAmount, context.currency);
      var lineTotal = moneyCents(line.cost.totalAmount, context.currency);
      var cartSubtotal = moneyCents(cart.cost.subtotalAmount, context.currency);
      var total = moneyCents(cart.cost.totalAmount, context.currency);
      var nativeSubtotal = unit * context.quantity;
      requireValue(unit > 0 && Number.isSafeInteger(nativeSubtotal) && nativeSubtotal > 0 && subtotal === nativeSubtotal, 'BASE_PRICE_MISMATCH');
      var regularUnit = nativeBaseline ? unit : context.unitCents;
      var planLabel = '';
      if (context.sellingPlanId) {
        var allocation = line.sellingPlanAllocation;
        requireValue(Array.isArray(allocation.priceAdjustments) && allocation.priceAdjustments.length > 0 && allocation.priceAdjustments.length <= 2, 'UNSUPPORTED_SELLING_PLAN_PRICE');
        var adjustment = allocation.priceAdjustments[0];
        var planUnit = moneyCents(adjustment && adjustment.price, context.currency);
        regularUnit = moneyCents(adjustment && adjustment.compareAtPrice, context.currency);
        requireValue(planUnit === unit && regularUnit >= planUnit && (nativeBaseline || regularUnit === context.unitCents), 'BASE_PRICE_MISMATCH');
        requireValue(typeof allocation.sellingPlan.name === 'string' && allocation.sellingPlan.name.trim().length > 0 && allocation.sellingPlan.name.length <= 255, 'UNSUPPORTED_SELLING_PLAN_PRICE');
        planLabel = allocation.sellingPlan.name;
      } else requireValue(nativeBaseline || unit === context.unitCents, 'BASE_PRICE_MISMATCH');
      var regularSubtotal = regularUnit * context.quantity;
      requireValue(Number.isSafeInteger(regularSubtotal) && regularSubtotal > 0, 'BASE_PRICE_MISMATCH');
      requireValue(cartSubtotal >= total && cartSubtotal <= nativeSubtotal && lineTotal >= total && lineTotal <= nativeSubtotal && total <= nativeSubtotal, 'INVALID_QUOTE_TOTAL');
      requireValue(Array.isArray(line.discountAllocations) && Array.isArray(cart.discountCodes), 'INVALID_DISCOUNT_ALLOCATION');
      var appliedCodes = Object.create(null);
      cart.discountCodes.forEach(function (entry) {
        requireValue(entry && typeof entry.code === 'string' && typeof entry.applicable === 'boolean', 'INVALID_DISCOUNT_ALLOCATION');
        var normalized = entry.code.toUpperCase();
        requireValue(seenCodes[normalized] || (allowWelcome && normalized === welcomeCode.toUpperCase()), 'UNREGISTERED_DISCOUNT_CODE');
        requireValue(appliedCodes[normalized] === undefined, 'INVALID_DISCOUNT_ALLOCATION');
        appliedCodes[normalized] = entry.applicable;
      });
      var allocated = 0;
      var welcomeSaving = 0;
      var automatic = false;
      var planSaving = regularSubtotal - nativeSubtotal;
      var labels = planSaving > 0 ? [planLabel] : [];
      var activeCodes = [];
      line.discountAllocations.forEach(function (allocation) {
        requireValue(allocation && typeof allocation.__typename === 'string', 'INVALID_DISCOUNT_ALLOCATION');
        var amount = moneyCents(allocation.discountedAmount, context.currency);
        requireValue(amount > 0, 'INVALID_DISCOUNT_ALLOCATION');
        allocated += amount;
        requireValue(Number.isSafeInteger(allocated), 'INVALID_DISCOUNT_ALLOCATION');
        if (allocation.__typename === 'CartCodeDiscountAllocation') {
          requireValue(typeof allocation.code === 'string' && appliedCodes[allocation.code.toUpperCase()] === true, 'INVALID_DISCOUNT_ALLOCATION');
          var canonical = allocation.code.toUpperCase() === welcomeCode.toUpperCase() ? welcomeCode : publicCodes.filter(function (code) { return code.toUpperCase() === allocation.code.toUpperCase(); })[0];
          requireValue(Boolean(canonical), 'UNREGISTERED_DISCOUNT_CODE');
          if (canonical.toUpperCase() === welcomeCode.toUpperCase()) welcomeSaving += amount;
          if (activeCodes.indexOf(canonical) === -1) activeCodes.push(canonical);
          if (labels.indexOf(canonical) === -1) labels.push(canonical);
        } else if (allocation.__typename === 'CartAutomaticDiscountAllocation') {
          requireValue(typeof allocation.title === 'string' && allocation.title.trim().length > 0 && allocation.title.length <= 255, 'INVALID_DISCOUNT_ALLOCATION');
          automatic = true;
          if (labels.indexOf(allocation.title) === -1) labels.push(allocation.title);
        } else throw failure('INVALID_DISCOUNT_ALLOCATION');
      });
      requireValue(allocated === nativeSubtotal - total, 'INVALID_DISCOUNT_ALLOCATION');
      requireValue(allocated > 0 || total === nativeSubtotal, 'INVALID_DISCOUNT_ALLOCATION');
      return {
        safe: {
          totalCents: total,
          subtotalCents: regularSubtotal,
          planSubtotalCents: nativeSubtotal,
          planSavingCents: planSaving,
          allocatedSavingCents: allocated,
          publicPlanOffer: planSaving > 0,
          currency: context.currency,
          label: labels.join(' + '),
          code: welcomeSaving > 0 ? welcomeCode : (activeCodes.length === 1 ? activeCodes[0] : null),
          automatic: automatic,
          discounted: allocated > 0 || planSaving > 0,
          quantity: context.quantity
        },
        welcomeSaving: welcomeSaving
      };
    }

    function sameQuote(left, right) {
      return left.totalCents === right.totalCents && left.subtotalCents === right.subtotalCents && left.planSubtotalCents === right.planSubtotalCents && left.planSavingCents === right.planSavingCents && left.allocatedSavingCents === right.allocatedSavingCents && left.publicPlanOffer === right.publicPlanOffer && left.currency === right.currency && left.code === right.code && left.label === right.label && left.automatic === right.automatic;
    }

    async function runQuote(context) {
      requireValue(!disposalRequested, 'SESSION_DISPOSED');
      requireValue(!failed, 'SESSION_FAILED');
      var budget = {count: 0};
      var cart;
      if (cartId === null) {
        requireValue(!createAttempted, 'CART_CREATION_UNCONFIRMED');
        createAttempted = true;
        var inputLine = {merchandiseId: context.variantId, quantity: context.quantity};
        if (context.sellingPlanId) inputLine.sellingPlanId = context.sellingPlanId;
        cart = await request('create', {input: {buyerIdentity: {countryCode: context.country}, discountCodes: [], lines: [inputLine]}}, budget);
      } else {
        requireValue(typeof lineId === 'string' && lineId.length > 0, 'INVALID_QUOTE_LINES');
        cart = await request('prepare', {cartId: cartId, country: context.country, lines: [{id: lineId, merchandiseId: context.variantId, quantity: context.quantity, sellingPlanId: context.sellingPlanId}]}, budget);
      }
      var publicQuote = quoteFromCart(cart, context, false, false);
      if (publicCodes.length > 0) {
        cart = await request('codes', {cartId: cartId, codes: publicCodes.slice()}, budget);
        publicQuote = quoteFromCart(cart, context, false, false);
      }
      var selected = publicQuote;
      if (context.customerStatus !== 'returning' && !(context.customerStatus === 'guest' && publicQuote.safe.discounted)) {
        cart = await request('codes', {cartId: cartId, codes: publicCodes.concat([welcomeCode])}, budget);
        var welcomeQuote = quoteFromCart(cart, context, true, false);
        requireValue(welcomeQuote.safe.planSubtotalCents === publicQuote.safe.planSubtotalCents, 'SELLING_PLAN_PRICE_CHANGED');
        if (welcomeQuote.welcomeSaving > 0 && welcomeQuote.safe.totalCents < publicQuote.safe.totalCents) selected = welcomeQuote;
        else {
          cart = await request('codes', {cartId: cartId, codes: publicCodes.slice()}, budget);
          var restoredPublic = quoteFromCart(cart, context, false, false);
          requireValue(sameQuote(restoredPublic.safe, publicQuote.safe), 'QUOTE_CHANGED');
          selected = restoredPublic;
        }
      }
      if (selected.welcomeSaving > 0) {
        if (context.currency === 'USD') selected.safe.usdSavingCents = selected.welcomeSaving;
        else {
          var usdContext = {
            variantId: context.variantId,
            sellingPlanId: context.sellingPlanId,
            quantity: context.quantity,
            country: 'US',
            currency: 'USD',
            unitCents: null,
            customerStatus: context.customerStatus
          };
          var nativeQuote;
          var restored;
          try {
            cart = await request('country', {cartId: cartId, country: 'US'}, budget);
            nativeQuote = quoteFromCart(cart, usdContext, true, true);
            requireValue(nativeQuote.welcomeSaving > 0, 'NATIVE_WELCOME_UNAVAILABLE');
          } finally {
            cart = await request('country', {cartId: cartId, country: context.country}, budget, true);
            restored = quoteFromCart(cart, context, true, false);
            requireValue(restored.welcomeSaving > 0 && sameQuote(restored.safe, selected.safe), 'QUOTE_CHANGED');
          }
          selected = restored;
          selected.safe.usdSavingCents = nativeQuote.welcomeSaving;
        }
      }
      requireValue(!disposalRequested, 'SESSION_DISPOSED');
      return Object.freeze(selected.safe);
    }

    function quote(context) {
      var copied;
      try {
        requireValue(!disposalRequested, 'SESSION_DISPOSED');
        copied = contextCopy(context);
      } catch (error) {
        return Promise.reject(error);
      }
      return serialize(async function () {
        try {
          return await runQuote(copied);
        } catch (error) {
          failed = true;
          throw error;
        }
      });
    }

    function dispose() {
      if (disposalPromise) return disposalPromise;
      disposalRequested = true;
      disposalPromise = serialize(async function () {
        try {
          if (cartId === null) {
            requireValue(!createAttempted, 'CLEANUP_UNCONFIRMED');
            return {cleaned: true};
          }
          requireValue(cleanupLineIds.length > 0, 'CLEANUP_UNCONFIRMED');
          var cart = await request('cleanup', {cartId: cartId, lineIds: cleanupLineIds.slice()}, {count: 0});
          requireValue(cart.id === cartId && cart.lines && Array.isArray(cart.lines.nodes) && cart.lines.nodes.length === 0 && cart.lines.pageInfo && cart.lines.pageInfo.hasNextPage === false && Array.isArray(cart.discountCodes) && cart.discountCodes.length === 0, 'CLEANUP_UNCONFIRMED');
          return {cleaned: true};
        } finally {
          cartId = null;
          lineId = null;
          cleanupLineIds = [];
          failed = true;
        }
      });
      return disposalPromise;
    }

    return Object.freeze({quote: quote, dispose: dispose});
  }

  function attributeCopy(value) {
    requireValue(Array.isArray(value) && value.length <= 250, 'INVALID_BASKET_ATTRIBUTES');
    var seen = Object.create(null);
    return value.map(function (attribute) {
      requireValue(attribute && typeof attribute.key === 'string' && attribute.key.length > 0 && attribute.key.length <= 255 && typeof attribute.value === 'string' && attribute.value.length <= 10000 && !seen[attribute.key], 'INVALID_BASKET_ATTRIBUTES');
      seen[attribute.key] = true;
      return {key: attribute.key, value: attribute.value};
    }).sort(function (left, right) { return left.key.localeCompare(right.key); });
  }

  function basketLineKey(line) {
    return JSON.stringify([line.variantId, line.sellingPlanId, line.attributes]);
  }

  function basketCopy(value) {
    var context = contextCopy(value);
    var basket = value.basket;
    requireValue(basket && Array.isArray(basket.lines) && basket.lines.length > 0 && basket.lines.length <= 100 && typeof basket.note === 'string' && basket.note.length <= 10000, 'INVALID_BASKET');
    var seen = Object.create(null);
    var quantity = 0;
    var subtotal = 0;
    var lines = basket.lines.map(function (line) {
      requireValue(line && safeInteger(line.quantity) && line.quantity > 0 && line.quantity <= 1000 && safeInteger(line.unitCents) && line.unitCents > 0 && safeInteger(line.planCents) && line.planCents > 0 && line.planCents <= line.unitCents, 'INVALID_BASKET');
      var copy = {variantId: resourceId(line.variantId, 'ProductVariant', false), sellingPlanId: resourceId(line.sellingPlanId, 'SellingPlan', true), quantity: line.quantity, unitCents: line.unitCents, planCents: line.planCents, attributes: attributeCopy(line.attributes)};
      requireValue(copy.sellingPlanId || copy.planCents === copy.unitCents, 'INVALID_BASKET');
      var key = basketLineKey(copy);
      requireValue(!seen[key], 'INVALID_BASKET');
      seen[key] = true;
      quantity += copy.quantity;
      subtotal += copy.unitCents * copy.quantity;
      requireValue(Number.isSafeInteger(subtotal) && quantity <= 1000, 'INVALID_BASKET');
      return copy;
    }).sort(function (left, right) { return basketLineKey(left).localeCompare(basketLineKey(right)); });
    requireValue(Array.isArray(basket.codes) && basket.codes.length <= 5, 'INVALID_BASKET_CODES');
    var codes = basket.codes.map(function (entry) {
      requireValue(entry && typeof entry.applicable === 'boolean', 'INVALID_BASKET_CODES');
      var name = codeValue(entry.code);
      requireValue(!seen['code:' + name.toUpperCase()], 'INVALID_BASKET_CODES');
      seen['code:' + name.toUpperCase()] = true;
      return {code: name, applicable: entry.applicable};
    });
    var target = {variantId: context.variantId, sellingPlanId: context.sellingPlanId, attributes: attributeCopy(basket.targetAttributes)};
    requireValue(lines.some(function (line) { return basketLineKey(line) === basketLineKey(target); }), 'INVALID_BASKET_TARGET');
    context.basket = {lines: lines, attributes: attributeCopy(basket.attributes), note: basket.note, codes: codes, targetAttributes: target.attributes};
    return context;
  }

  function createBasketSession(fetchImpl, endpoint, options) {
    var welcomeCode = codeValue(options && options.welcomeCode !== undefined ? options.welcomeCode : 'Welcome20');
    var publicCodes = options && options.publicCodes ? options.publicCodes.slice() : [];
    var fields = cartFields.replace('id totalQuantity buyerIdentity', 'id totalQuantity attributes { key value } note buyerIdentity').replace('lines(first: 2)', 'lines(first: 100)').replace('id quantity merchandise', 'id quantity attributes { key value } merchandise');
    var basketOperations = {
      create: 'mutation OfferBasketCreate($input: CartInput!) { result: cartCreate(input: $input) { cart { ...OfferCart } userErrors { code } warnings { code } } } ' + fields,
      replace: 'mutation OfferBasketReplace($cartId: ID!, $lineIds: [ID!]!, $lines: [CartLineInput!]!, $country: CountryCode!, $attributes: [AttributeInput!]!, $note: String!, $codes: [String!]!) { reset: cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $codes) { userErrors { code } warnings { code } } identity: cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: {countryCode: $country}) { userErrors { code } warnings { code } } remove: cartLinesRemove(cartId: $cartId, lineIds: $lineIds) { userErrors { code } warnings { code } } attributes: cartAttributesUpdate(cartId: $cartId, attributes: $attributes) { userErrors { code } warnings { code } } note: cartNoteUpdate(cartId: $cartId, note: $note) { userErrors { code } warnings { code } } result: cartLinesAdd(cartId: $cartId, lines: $lines) { cart { ...OfferCart } userErrors { code } warnings { code } } } ' + fields,
      codes: operations.codes.replace(cartFields, fields),
      country: operations.country.replace(cartFields, fields),
      cleanup: 'mutation OfferBasketCleanup($cartId: ID!, $lineIds: [ID!]!) { reset: cartDiscountCodesUpdate(cartId: $cartId, discountCodes: []) { userErrors { code } warnings { code } } attributes: cartAttributesUpdate(cartId: $cartId, attributes: []) { userErrors { code } warnings { code } } note: cartNoteUpdate(cartId: $cartId, note: "") { userErrors { code } warnings { code } } result: cartLinesRemove(cartId: $cartId, lineIds: $lineIds) { cart { id attributes { key value } note lines(first: 100) { nodes { id } pageInfo { hasNextPage } } discountCodes { code applicable } } userErrors { code } warnings { code } } }'
    };
    var cartId = null;
    var lineIds = [];
    var created = false;
    var stopped = false;
    var disposed = false;
    var disposal;
    var queue = Promise.resolve();

    function serialize(action) {
      var pending = queue.then(action, action);
      queue = pending.catch(function () {});
      return pending;
    }

    async function requestBasket(operation, variables, budget, cleanup) {
      requireValue(!disposed || cleanup, 'SESSION_DISPOSED');
      requireValue(++budget.count <= 8, 'REQUEST_BUDGET_EXCEEDED');
      var body;
      try {
        var response = await fetchImpl(endpoint, {method: 'POST', credentials: 'omit', cache: 'no-store', redirect: 'error', keepalive: Boolean(cleanup), headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({query: basketOperations[operation], variables: variables})});
        requireValue(response && response.ok === true, 'QUOTE_REQUEST_FAILED');
        body = await response.json();
      } catch (_) { throw failure('QUOTE_REQUEST_FAILED'); }
      var returned = body && body.data && body.data.result && body.data.result.cart;
      if (returned && typeof returned.id === 'string') {
        requireValue(!cartId || cartId === returned.id, 'CART_CONTEXT_MISMATCH');
        cartId = returned.id;
        if (returned.lines && Array.isArray(returned.lines.nodes)) lineIds = returned.lines.nodes.map(function (line) { return line.id; });
      }
      requireValue(body && (!body.errors || body.errors.length === 0) && body.data, 'QUOTE_ENGINE_ERROR');
      Object.keys(body.data).forEach(function (key) {
        var payload = body.data[key];
        requireValue(payload && Array.isArray(payload.userErrors) && payload.userErrors.length === 0, 'QUOTE_ENGINE_ERROR');
        requireValue(Array.isArray(payload.warnings) && payload.warnings.every(function (warning) { return operation === 'codes' && key === 'result' && warning && ineligibleCodeWarnings.indexOf(warning.code) !== -1; }), 'QUOTE_ENGINE_WARNING');
      });
      requireValue(returned, 'QUOTE_ENGINE_ERROR');
      return returned;
    }

    function readBasket(cart, context, requestedCodes, nativeBaseline) {
      var basket = context.basket;
      requireValue(cart && cart.id === cartId && cart.buyerIdentity && cart.buyerIdentity.countryCode === context.country && JSON.stringify(attributeCopy(cart.attributes)) === JSON.stringify(basket.attributes) && (cart.note || '') === basket.note, 'CART_CONTEXT_MISMATCH');
      requireValue(cart.lines && Array.isArray(cart.lines.nodes) && cart.lines.nodes.length === basket.lines.length && cart.lines.pageInfo && cart.lines.pageInfo.hasNextPage === false && Array.isArray(cart.discountCodes), 'INVALID_QUOTE_LINES');
      var codeStates = Object.create(null);
      cart.discountCodes.forEach(function (entry) {
        requireValue(entry && typeof entry.applicable === 'boolean' && typeof entry.code === 'string' && requestedCodes.some(function (code) { return code.toUpperCase() === entry.code.toUpperCase(); }) && codeStates[entry.code.toUpperCase()] === undefined, 'INVALID_DISCOUNT_ALLOCATION');
        codeStates[entry.code.toUpperCase()] = entry.applicable;
      });
      requireValue(requestedCodes.every(function (code) { return codeStates[code.toUpperCase()] !== undefined; }), 'INVALID_DISCOUNT_ALLOCATION');
      var quantity = 0;
      var regular = 0;
      var native = 0;
      var allocated = 0;
      var welcomeSaving = 0;
      var targetSaving = 0;
      var targetWelcome = 0;
      var targetPlanSaving = 0;
      var labels = [];
      var targetCodes = [];
      var targetKey = basketLineKey({variantId: context.variantId, sellingPlanId: context.sellingPlanId, attributes: basket.targetAttributes});
      var seen = Object.create(null);
      cart.lines.nodes.forEach(function (line) {
        var plan = line.sellingPlanAllocation && line.sellingPlanAllocation.sellingPlan;
        var key = basketLineKey({variantId: line.merchandise && line.merchandise.id, sellingPlanId: plan ? plan.id : null, attributes: attributeCopy(line.attributes)});
        var expected = basket.lines.filter(function (candidate) { return basketLineKey(candidate) === key; });
        requireValue(expected.length === 1 && !seen[key] && line.quantity === expected[0].quantity, 'CART_CONTEXT_MISMATCH');
        seen[key] = true;
        expected = expected[0];
        var unit = moneyCents(line.cost && line.cost.amountPerQuantity, context.currency);
        var unitRegular = unit;
        var target = key === targetKey;
        if (plan) {
          var adjustments = line.sellingPlanAllocation.priceAdjustments;
          requireValue(Array.isArray(adjustments) && adjustments.length > 0 && adjustments.length <= 2, 'UNSUPPORTED_SELLING_PLAN_PRICE');
          unitRegular = moneyCents(adjustments[0].compareAtPrice, context.currency);
          requireValue(moneyCents(adjustments[0].price, context.currency) === unit && typeof plan.name === 'string' && plan.name.trim() && plan.name.length <= 255, 'UNSUPPORTED_SELLING_PLAN_PRICE');
          if (target && unitRegular > unit) labels.push(plan.name);
        }
        requireValue(unit > 0 && unitRegular >= unit && (nativeBaseline || (unit === expected.planCents && unitRegular === expected.unitCents)) && moneyCents(line.cost.subtotalAmount, context.currency) === unit * line.quantity, 'BASE_PRICE_MISMATCH');
        var lineTotal = moneyCents(line.cost.totalAmount, context.currency);
        requireValue(lineTotal >= 0 && lineTotal <= unit * line.quantity && Array.isArray(line.discountAllocations), 'INVALID_QUOTE_TOTAL');
        quantity += line.quantity;
        regular += unitRegular * line.quantity;
        native += unit * line.quantity;
        if (target) targetPlanSaving = (unitRegular - unit) * line.quantity;
        line.discountAllocations.forEach(function (allocation) {
          var amount = moneyCents(allocation && allocation.discountedAmount, context.currency);
          requireValue(amount > 0, 'INVALID_DISCOUNT_ALLOCATION');
          allocated += amount;
          if (target) targetSaving += amount;
          var label;
          if (allocation.__typename === 'CartCodeDiscountAllocation') {
            requireValue(typeof allocation.code === 'string' && codeStates[allocation.code.toUpperCase()] === true, 'INVALID_DISCOUNT_ALLOCATION');
            label = requestedCodes.filter(function (code) { return code.toUpperCase() === allocation.code.toUpperCase(); })[0];
            if (allocation.code.toUpperCase() === welcomeCode.toUpperCase()) { welcomeSaving += amount; if (target) targetWelcome += amount; }
            if (target && targetCodes.indexOf(label) === -1) targetCodes.push(label);
          } else {
            requireValue(allocation.__typename === 'CartAutomaticDiscountAllocation' && typeof allocation.title === 'string' && allocation.title.trim() && allocation.title.length <= 255, 'INVALID_DISCOUNT_ALLOCATION');
            label = allocation.title;
          }
          if (target && labels.indexOf(label) === -1) labels.push(label);
        });
      });
      var total = moneyCents(cart.cost && cart.cost.totalAmount, context.currency);
      var subtotal = moneyCents(cart.cost && cart.cost.subtotalAmount, context.currency);
      requireValue(Number.isSafeInteger(regular) && Number.isSafeInteger(native) && Number.isSafeInteger(allocated) && quantity === cart.totalQuantity && subtotal >= total && subtotal <= native && allocated === native - total, 'INVALID_QUOTE_TOTAL');
      return {safe: {basket: true, singleTarget: basket.lines.length === 1 && quantity === 1, totalCents: total, subtotalCents: regular, planSubtotalCents: native, planSavingCents: regular - native, allocatedSavingCents: allocated, publicPlanOffer: targetPlanSaving > 0, badgeSavingCents: targetSaving + targetPlanSaving, targetDiscounted: targetSaving + targetPlanSaving > 0, discounted: targetSaving + targetPlanSaving > 0, currency: context.currency, quantity: context.quantity, basketQuantity: quantity, label: labels.join(' + '), code: targetWelcome > 0 ? welcomeCode : (targetCodes.length === 1 ? targetCodes[0] : null), applyCodes: requestedCodes.slice(), codeStates: requestedCodes.map(function (code) { return {code: code, applicable: codeStates[code.toUpperCase()]}; })}, welcomeSaving: welcomeSaving, targetWelcome: targetWelcome};
    }

    function preserved(before, after) {
      return before.safe.codeStates.every(function (entry) { return !entry.applicable || after.safe.codeStates.some(function (candidate) { return candidate.code.toUpperCase() === entry.code.toUpperCase() && candidate.applicable; }); });
    }

    async function run(context) {
      requireValue(!stopped && !disposed, 'SESSION_FAILED');
      var basket = context.basket;
      var codes = basket.codes.map(function (entry) { return entry.code; });
      publicCodes.forEach(function (code) { if (!codes.some(function (entry) { return entry.toUpperCase() === code.toUpperCase(); })) codes.push(code); });
      var lines = basket.lines.map(function (line) { var input = {merchandiseId: line.variantId, quantity: line.quantity, attributes: line.attributes}; if (line.sellingPlanId) input.sellingPlanId = line.sellingPlanId; return input; });
      var budget = {count: 0};
      var cart;
      if (!cartId) {
        requireValue(!created, 'CART_CREATION_UNCONFIRMED');
        created = true;
        cart = await requestBasket('create', {input: {buyerIdentity: {countryCode: context.country}, discountCodes: [], lines: lines, attributes: basket.attributes, note: basket.note}}, budget);
      } else cart = await requestBasket('replace', {cartId: cartId, lineIds: lineIds.slice(), lines: lines, country: context.country, attributes: basket.attributes, note: basket.note, codes: []}, budget);
      if (codes.length) cart = await requestBasket('codes', {cartId: cartId, codes: codes}, budget);
      var baseline = readBasket(cart, context, codes, false);
      requireValue(basket.codes.every(function (entry) { return !entry.applicable || baseline.safe.codeStates.some(function (candidate) { return candidate.code.toUpperCase() === entry.code.toUpperCase() && candidate.applicable; }); }), 'EXISTING_DISCOUNT_CHANGED');
      var selected = baseline;
      if (context.customerStatus !== 'returning' && !(context.customerStatus === 'guest' && baseline.safe.discounted) && !codes.some(function (entry) { return entry.toUpperCase() === welcomeCode.toUpperCase(); })) {
        var trialCodes = codes.concat([welcomeCode]);
        cart = await requestBasket('codes', {cartId: cartId, codes: trialCodes}, budget);
        var trial = readBasket(cart, context, trialCodes, false);
        if (trial.targetWelcome > 0 && trial.safe.totalCents < baseline.safe.totalCents && trial.safe.planSubtotalCents === baseline.safe.planSubtotalCents && preserved(baseline, trial)) selected = trial;
        else {
          cart = await requestBasket('codes', {cartId: cartId, codes: codes}, budget);
          var restored = readBasket(cart, context, codes, false);
          requireValue(JSON.stringify(restored.safe) === JSON.stringify(baseline.safe), 'QUOTE_CHANGED');
          selected = restored;
        }
      }
      if (selected.targetWelcome > 0) {
        if (context.currency === 'USD') selected.safe.usdSavingCents = selected.welcomeSaving;
        else {
          var usdContext = Object.assign({}, context, {country: 'US', currency: 'USD'});
          var usd;
          try {
            cart = await requestBasket('country', {cartId: cartId, country: 'US'}, budget);
            usd = readBasket(cart, usdContext, selected.safe.applyCodes, true);
            requireValue(usd.targetWelcome > 0, 'NATIVE_WELCOME_UNAVAILABLE');
          } finally {
            cart = await requestBasket('country', {cartId: cartId, country: context.country}, budget);
            var local = readBasket(cart, context, selected.safe.applyCodes, false);
            requireValue(JSON.stringify(local.safe) === JSON.stringify(selected.safe), 'QUOTE_CHANGED');
          }
          selected.safe.usdSavingCents = usd.welcomeSaving;
        }
      }
      requireValue(!disposed, 'SESSION_DISPOSED');
      return Object.freeze(selected.safe);
    }

    return {
      quote: function (value) {
        var context;
        try { context = basketCopy(value); } catch (error) { return Promise.reject(error); }
        return serialize(async function () {
          try { return await run(context); }
          catch (error) { stopped = true; throw error; }
        });
      },
      dispose: function () {
        if (disposal) return disposal;
        disposed = true;
        disposal = serialize(async function () {
          try {
            if (!cartId) {
              requireValue(!created, 'CLEANUP_UNCONFIRMED');
              return {cleaned: true};
            }
            requireValue(lineIds.length > 0, 'CLEANUP_UNCONFIRMED');
            var cart = await requestBasket('cleanup', {cartId: cartId, lineIds: lineIds.slice()}, {count: 0}, true);
            requireValue(cart.id === cartId && cart.lines && cart.lines.nodes.length === 0 && cart.lines.pageInfo.hasNextPage === false && cart.discountCodes.length === 0 && attributeCopy(cart.attributes).length === 0 && !cart.note, 'CLEANUP_UNCONFIRMED');
            return {cleaned: true};
          } finally { cartId = null; lineIds = []; stopped = true; }
        });
        return disposal;
      }
    };
  }

  function createSession(fetchImpl, endpoint, options) {
    var single = createSingleSession(fetchImpl, endpoint, options);
    var basket;
    var disposed = false;
    var disposal;
    return Object.freeze({
      quote: function (context) {
        if (disposed) return Promise.reject(failure('SESSION_DISPOSED'));
        if (context && context.basket) {
          if (!basket) basket = createBasketSession(fetchImpl, endpoint, options);
          return basket.quote(context);
        }
        return single.quote(context);
      },
      dispose: function () {
        if (!disposal) {
          disposed = true;
          disposal = Promise.all([single.dispose(), basket ? basket.dispose() : Promise.resolve({cleaned: true})]).then(function () { return {cleaned: true}; });
        }
        return disposal;
      }
    });
  }

  return Object.freeze({createSession: createSession});
}));
